import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    add: [],
    token: '',
    userName: '',
    // userInfo: {}//用户信息
  },
  getters: {
  },
  mutations: {
    SET_DATA(state, payload) {
      state.add = payload
      console.log(state.add);
      state.add.token = payload.token
      console.log(state.add.token);
    },
    GET_DATA(state, payload) {
      state.userName = payload
      console.log(state.add);
    },
    //修改用户信息
    // SET_USERINFO(state, payload) {
    //   state.userInfo = payload
    // },xia
  },
  actions: {

  },
  modules: {
  }
})
